export type UpdateWork = {
  awdKeyId: string;
  comment: string;
  assignTo: string;
  lock: boolean;
  businessAreaName: string;
  typeName: string;
  statusName: string;
  queueName: string;
  fieldValues: valueType[];
  priorityIncrease: number;
};

export const updateWork: UpdateWork = {
  awdKeyId: '',
  comment: '',
  assignTo: '',
  lock: false,
  businessAreaName: '',
  typeName: '',
  statusName: '',
  queueName: '',
  fieldValues: [
    {
      name: 'TEAM',
      value: '',
    },
  ],
  priorityIncrease: 0,
};

export type valueType = {
  name: string;
  value: string;
};
